import {useEffect, useRef, useState} from "react";
import {Body, BodyScroll, Desc, Footer, Images, Logo, Next, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import Consent from "./consent";
import Verify from "./verify";
import {ContainerImage} from "../../components/Container";
import {useNavigate} from "react-router-dom";
import {Modal} from "antd";
import CarouselImages from "../../components/Carousel";
import {sleep} from "../../services/app";
import moment from "moment";

export default function Campaign(props: any) {
    const {campaign, customer, T, business, clientCode} = useApp();
    const [step, setStep] = useState("");
    const nextUrlRef = useRef();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const bodyRef = useRef(null);

    const campaignImages = campaign?.imageUrls?.length ? campaign?.imageUrls.map(x => x.url) : []

    // Book Now button visibility is gated by bookingOpenDate (falls back to
    // startDate when the admin left it empty — this mirrors the admin's
    // "default" contract). The URL/landing page itself is NOT gated here —
    // that's Service Period only (enforced server-side). Backend formats
    // bookingOpenDate / startDate as MM/DD/YYYY, so moment's strict parser
    // reads them reliably.
    const effectiveOpenDateStr = campaign?.bookingOpenDate || campaign?.startDate || null;
    const effectiveOpenDate = effectiveOpenDateStr
        ? moment(effectiveOpenDateStr, "MM/DD/YYYY", true)
        : null;
    const today = moment().startOf("day");
    const isBeforeBookingOpen =
        !!effectiveOpenDate && effectiveOpenDate.isValid() && today.isBefore(effectiveOpenDate, "day");

    return (
        <>
            <ContainerImage style={{height: '100%'}}>
                <Logo>
                    {business?.logoWide || business?.logoUrl || business?.logoFavicon ? (
                        <img src={business?.logoWide || business?.logoUrl || business?.logoFavicon}/>) : (<LogoIcon/>)}
                </Logo>
                <BodyScroll ref={bodyRef}>
                    <Body>
                        <Images>
                            <CarouselImages height={300}
                                            imageUrls={campaignImages?.length ? campaignImages : ["/assets/images/default_camp.png"]}/>
                        </Images>
                        <Title>{campaign?.name}</Title>
                        <Desc dangerouslySetInnerHTML={{__html: campaign?.descriptions}}></Desc>
                    </Body>
                </BodyScroll>
                <Footer>
                    {isBeforeBookingOpen ? (
                        // Before bookingOpenDate → hide the CTA and show when
                        // booking opens. The landing page remains fully
                        // reachable during the whole Service Period.
                        <Next
                            disabled
                            style={{opacity: 0.7, cursor: "not-allowed"}}
                            onClick={() => {}}
                        >
                            {T("Opens")} {effectiveOpenDate?.format("MMM D, YYYY")}
                        </Next>
                    ) : (
                        <Next
                            loading={loading}
                            onClick={() => setStep("verify")}>{campaign?.customButtonText?.trim() || T("Get Started")}</Next>
                    )}
                </Footer>
                <Modal centered open={step === 'consent'} modalRender={() => (
                    <Consent onClose={event => {
                        setStep("");
                        if (event) {
                            navigate(nextUrlRef.current);
                        }
                    }}/>
                )}/>
                <Modal destroyOnClose centered open={step === 'verify'} modalRender={() => (
                    <Verify onLoading={setLoading} visible={step === 'verify'} onClose={event => {
                        if (event) {
                            nextUrlRef.current = event;
                            if (campaign?.isOffConsentForm) {
                                // force next
                                navigate(nextUrlRef.current);
                            } else {
                                setStep('consent');
                            }
                        } else {
                            setStep("")
                        }
                    }}/>
                )}/>
            </ContainerImage>
        </>
    );
}
